import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, homeFor } from "@/context/AuthContext";
import { Btn, Card, Field, Input, labelCls } from "@/components/Ui";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const user = await login(form.email, form.password);
      toast.success("Signed in");
      navigate(params.get("next") || homeFor(user.role), { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-5 py-16" data-testid="login-page">
      <h1 className="font-display text-3xl font-black tracking-tight text-[#102A43]">Sign in</h1>
      <p className="mt-2 text-sm text-[#667788]">
        Buyers, suppliers and ADIT administrators use the same sign-in.
      </p>
      <Card className="mt-7">
        <form onSubmit={submit}>
          <Field label="Email">
            <Input
              data-testid="login-email-input"
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </Field>
          <div className="mt-4">
            <label className={labelCls}>Password</label>
            <Input
              data-testid="login-password-input"
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </div>
          {error && (
            <p data-testid="login-error" className="mt-4 rounded-[9px] bg-[#fdecec] px-3 py-2 text-sm text-[#B42318]">
              {error}
            </p>
          )}
          <Btn data-testid="login-submit-btn" loading={busy} className="mt-6 w-full">
            Sign in
          </Btn>
        </form>
        <p className="mt-4 text-center text-sm">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="font-semibold text-[#147D78] underline">
            Forgot your password?
          </Link>
        </p>
        <p className="mt-5 text-center text-sm text-[#667788]">
          No account yet?{" "}
          <Link to="/register" data-testid="login-register-link" className="font-semibold text-[#147D78] underline">
            Create a buyer or supplier account
          </Link>
        </p>
      </Card>
    </div>
  );
}
